module.exports = __webpack_public_path__ + "img/toHeardBg.3090b765.png";